import React, { Component } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { trackingWrapper } from "../utils/analytics";
import { GAME_STATUS_AWARD_REWARD, GAME_STATUS_REPLAY, GAME_STATUS_START } from "../actions/game";

class AnalyticsContainer extends Component {
  componentDidMount() {
  }

  componentDidUpdate(prevProps) {
    const { gameStatus } = this.props,
      isGameStatusChanged = gameStatus !== prevProps.gameStatus;

    if (isGameStatusChanged) {
      if (gameStatus===GAME_STATUS_START) {
        trackingWrapper('CRgame-begin-round');
      }
  
      if (gameStatus===GAME_STATUS_REPLAY) {
        trackingWrapper('CRgame-replay');
      }

      if (gameStatus===GAME_STATUS_AWARD_REWARD) {
        trackingWrapper('CRgame-reward-applied');
      }
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = state => ({
  gameStatus: state.game.status
});

const mapDispatchToProps = dispatch => ({
});

AnalyticsContainer.propTypes = {
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AnalyticsContainer);



// WEBPACK FOOTER //
// ./src/containers/AnalyticsContainer.js